module.exports = __webpack_public_path__ + "static/media/2000px-Pin_svg (77)_flat_new.1d0f7d67.svg";


//////////////////
// WEBPACK FOOTER
// ./src/2000px-Pin_svg (77)_flat_new.svg
// module id = 233
// module chunks = 0